import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";

import { NewsMenu } from "./NewsMenu";
import { SyncBanner } from "./SyncBanner";

export function Layout({ children }: { children: ReactNode }) {
  const { t, i18n } = useTranslation();
  const { instance, accounts } = useMsal();
  const name = accounts[0]?.name ?? "";

  return (
    <div className="layout">
      <header className="brandbar">
        <a className="brand" href="/calendar" aria-label="Gatewatcher whosout">
          <img src="/gw-mark.svg" alt="" className="brand-mark" />
          GATEWATCHER
        </a>
        <div className="app-name">whosout</div>
        <nav>
          <NavLink to="/calendar" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("nav.calendar")}
          </NavLink>
          <NavLink to="/settings" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("nav.settings")}
          </NavLink>
        </nav>
        <div className="spacer" />
        <div className="user-chip">
          <NewsMenu />
          <select
            value={i18n.language.startsWith("fr") ? "fr" : "en"}
            onChange={(e) => void i18n.changeLanguage(e.target.value)}
            aria-label="language"
            className="lang-select"
          >
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </select>
          <span>{name}</span>
          <button className="ghost" onClick={() => void instance.logoutRedirect()}>
            {t("nav.signOut")}
          </button>
        </div>
      </header>
      <SyncBanner />
      <main>{children}</main>
    </div>
  );
}
